import React from 'react'

const SmsVasIcon = () => {
    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width={512}
                height={512}
                x={0}
                y={0}
                viewBox="0 0 81 63.8"
                style={{ enableBackground: "new 0 0 512 512" }}
                xmlSpace="preserve"
                className="card-svg"
            >
                <g>
                    <path
                        d="M60 8H12C5.4 8 0 13.4 0 20v20c0 6.6 5.4 12 12 12h6c2.2 0 4 1.8 4 4v1.8c0 4.6 4.9 7.4 8.9 5.2l18.3-10.2c.9-.5 1.9-.8 2.9-.8H60c6.6 0 12-5.4 12-12V20c0-6.6-5.4-12-12-12zM20 35c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4zm16 0c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4zm16 0c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4z"
                        className="hovered-path"
                        style={{}}
                        fill="#686df2"
                        data-original="#686df2"
                    />
                    <circle
                        cx={69}
                        cy={12}
                        r={12}
                        className="st1"
                        style={{}}
                        fill="#00e7cb"
                        data-original="#00e7cb"
                    />
                </g>
            </svg>

        </>
    )
}

export default SmsVasIcon